<template>
  <b-card no-body :id="'widgetppt' + widget.id">
    <div class="card-header" :class="{fixedCardHeader: isOverflown}">
      <span v-b-tooltip.hover :title="title" class="widget-title">{{title}}</span>
      <settings-button />
    </div>
    <b-card-body class="p-0 clearfix text-center" @click="handleClickThrough">
      <div v-if="loaded === true">
        <div class='number-box text-center px-3 py-2 m-2' v-for='(v, index) in value' :key='index'>
          <div v-if="typeof v === 'object' && v.compare_value">
            <div v-if="!hideMetricLabel" class="h5 my-2">{{ custom_titles(v, index) }}</div>
            <div class="h1 mt-3 mb-0">
              <div :id="'startBtn-' + index" class="comparing first-value" :class="colorValue(v)">{{ v.value }}</div>
              <b-tooltip :target="startDateId(index)">{{ startDate }} - {{ endDate }}</b-tooltip>
            </div>
            <div class="numbers-below">
              <div :id="'endBtn-' + index" class="comparing compare-value">{{ v.compare_value }}</div>
              <b-tooltip :target="endDateId(index)">{{ compareStartDate }} - {{ compareEndDate }}</b-tooltip>
              <div class="versus" :class="colorCompare(v)">
                <i :class="caret(v)" aria-hidden="true"></i>
                 {{ calcPercent(v) }}%
              </div>
            </div>
          </div>
          <div v-else>
            <div v-if="!hideMetricLabel" class="h5 my-2">{{ custom_titles(v, index) }}</div>
            <div class="h1 mt-3 mb-2">{{ v.data }}</div>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="h5 text-center p-2 loading-text">{{loadMessage}}</div>
      </div>
    </b-card-body>
    <div class="comparison-disclaimer" v-if="this.widget.disableDataComparison"><sup>*</sup>Data comparison unavailable</div>
  </b-card>
</template>

<script>
import { base_widget } from '@/views/widgets/base_widget'
import SettingsButton from '@/views/buttons/SettingsButton'
import { mapGetters } from 'vuex'

export default {
  name: 'NumberWidget',
  mixins: [base_widget],
  components: {
    SettingsButton
  },

  ...mapGetters([
  'startDate',
  'endDate',
  'compareStartDate',
  'compareEndDate'
  ]),

  data () {
    return {
      loaded: false,
      boxWidth: 0,
      loadMessage: 'Loading...',
      value: null
    }
  },
  methods: {
    custom_titles (v, index) {
      if (this.widget.widget_titles[index]){
        return this.widget.widget_titles[index]
      } else {
        return v.metrics
      }
    },

    setData (response){
      this.value = response.data.data
      var isLoaded = response.data.data.length
      if (isLoaded === 0) {
        this.loadMessage = 'No Data Available'
        this.saveWidgetData({}, [])
      } else {
        this.loaded = true
      }
      this.saveWidgetData(Object.values(this.value), Object.keys(this.value))
      this.widthUpdate()
    },
    colorValue (v) {
      let color = 'green';
      let percent = this.calcPercent(v)
      if (v.metrics !== 'Bounce Rate' && v.metrics !== 'Cost per click' && v.metrics !== 'CPM' && v.metrics !== 'Google Adwords Cost Per Conversion') {
        if (percent >= 0) {
           color = 'green'
        } else if (percent < -40) {
           color = 'red-damask'
        } else if (percent < -30) {
           color = 'fire-brush'
        } else if (percent < -20) {
           color = 'anzac'
        } else if (percent < -10) {
           color = 'pear'
        } else if (percent < 0) {
           color = 'lima'
        } else {
           color = 'red'
        }
      } else if (v.metrics && percent != 0) {
        if (percent < 0) {
           color = 'green'
        } else if (percent > 30) {
          color = 'red'
        } else if (percent > 20) {
           color = 'red-damask'
        } else if (percent > 15) {
           color = 'fire-brush'
        } else if (percent > 10) {
           color = 'anzac'
        } else if (percent > 5) {
           color = 'pear'
        } else {
           color = 'lima'
        }
      }
      return color;
    },
    colorCompare (v) {
      const percentage = this.calcPercent(v)
      if (percentage == 0) {
        return 'std-blue'
      } else if (v.metrics === 'Bounce Rate' || v.metrics === 'Cost per click' || v.metrics === 'CPM' || v.metrics === 'Google Adwords Cost Per Conversion') {
        return percentage > 0 ? 'std-red' : 'std-green'
      } else {
        return percentage < 0 ? 'std-red' : 'std-green'
      }
    },
    widthUpdate () {
      this.$nextTick(function() {
        var boxes = document.querySelectorAll(`#widgetppt${this.widget.id} .number-box`)
        var boxWidths = []
        for (var i = 0; i < boxes.length; i++) {
          boxWidths.push(boxes[i].offsetWidth)
        }
        this.boxWidth = Math.max(...boxWidths) + 12
        boxes.forEach((box) => {
          box.style.width = this.boxWidth + 'px'
          box.style.opacity = 1
        })
      })
    },
    startDateId (index) {
      return `startBtn-${index}`
    },
    endDateId (index) {
      return `endBtn-${index}`
    },
    calcPercent (v) {
      let currentVal;
      let prevVal;
      if (isNaN(v.value)) {
        currentVal = Number(v.value.replace(/[^0-9.]/g, ''))
      } else {
        currentVal = v.value
      }
      if (isNaN(v.compare_value)) {
        prevVal = Number(v.compare_value.replace(/[^0-9.]/g, ''))
      } else {
        prevVal = v.compare_value
      }
      let valDiff = currentVal - prevVal
      let percent = valDiff / prevVal * 100
      if (valDiff === 0) {
        return 0
      } else {
        return Math.round(percent * 100)/100
      }
    },
    caret (v) {
      if (this.calcPercent(v) === 0) {
        return null
      } else if (this.calcPercent(v) > 0) {
        return "fa fa-caret-up"
      } else {
        return "fa fa-caret-down"
      }
    }
  },
  watch: {
    compareStartDate () {
      this.loaded = false
      this.getData()
    },
    compareEndDate () {
      this.loaded = false
      this.getData()
    }
  }
}
</script>

<style scoped>
  .green {
    color: #1ABB9C;
  }
  .lima {
    color: #5dcd27;
  }
  .pear {
    color: #d8d82f;
  }
  .anzac {
    color: #dcb533;
  }
  .fire-brush {
    color: #e09236;
  }
  .red-damask {
    color: #e36f39;
  }
  .red {
    color: #E74C3C;
  }
  .std-blue {
    color: #3493B2;
  }
  .std-red {
    color: #C63F3F;
  }
  .std-green {
    color: #8DC63F;
  }
  .first-value {
    font-size: 40px;
    font-weight: 600;
  }
  .compare-value {
    font-size: .8rem;
    opacity: .6;
    display: inline-block;
    margin-right: 15px;
  }
  .number-box {
    position: relative;
    display: inline-block;
    color: #3493B2;
    background: #ECF6F9;
    border-radius: 6px;
    -webkit-transition: all 0.3s ease;
    -moz-transition: all 0.3s ease;
    -o-transition: all 0.3s ease;
    transition: all .3s ease;
    text-align: center;
    opacity: 0;
    vertical-align: top;
    font-family: 'Cooper Hewitt Medium';
    letter-spacing: 2px;
  }
  .number-box .h5 {
    text-transform: uppercase;
    font-size: 14px;
  }
  .number-box .versus {
    font-size: .8rem;
    display: inline-block;
  }
  .loading-text {
    color: #757575;
    text-align: center;
    margin-top: 10px;
    text-transform: uppercase;
    font-family: 'Cooper Hewitt Semibold';
    letter-spacing: 3px;
  }
</style>
